/**
 * "Nível de registro" (the owner's ask, 15/10): on Free, a session's log keeps what it always has; on a paid
 * plan the person may choose "Completo" — what the agent says on the way and each command whole, masked,
 * in the session's Detalhes, for as long as prompts are kept. Disabled on Free, with the plan named.
 */

import { Link } from 'react-router-dom'
import { useI18n } from '../lib/i18n'

export function LogLevelField({ full, allowed, onChange }: { full: boolean; allowed: boolean; onChange: (full: boolean) => void }) {
  const { t } = useI18n()
  return (
    <label className="field" style={{ maxWidth: 480 }}>
      <span className="field__label">{t('telemetry.logLevel')}</span>
      <select
        className="select"
        value={full && allowed ? 'full' : 'standard'}
        disabled={!allowed}
        onChange={(e) => onChange(e.target.value === 'full')}
      >
        <option value="standard">{t('telemetry.logLevelStandard')}</option>
        <option value="full">{t('telemetry.logLevelFull')}</option>
      </select>
      <span className="tiny muted">
        {t('telemetry.logLevelHint')}
        {!allowed && <> {t('telemetry.logLevelPaid')} <Link to="/settings/billing">{t('plans.upgrade')}</Link></>}
      </span>
    </label>
  )
}
